import { Container } from "@pixi/display";
import { ITextStyle, Text } from "@pixi/text";

export class AnimatedScore extends Container {
    private scoreText: Text;

    public constructor(
        startValue: number,
        textStyle: ITextStyle,
        private readonly isPercentage: boolean = false,
        private readonly scoreCountSpeed: number = 250
    ) {
        super();
        const initialText = isPercentage ? `${startValue.toFixed(1)}%` : startValue;
        this.scoreText = this.addChild(new Text(initialText, textStyle));
        this.scoreText.anchor.x = 0.5;
    }

    public async updateScore(score: number): Promise<void> {
        if (score.toString() == this.scoreText.text) {
            return;
        }
        this.scoreText.text = this.isPercentage ? `${score.toFixed(score === 100 ? 0 : 1)}%` : score;
    }
}